import React from "react";
import {
  Container,
  Typography,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
} from "@mui/material";

const Settings = () => {
  return (
    <Container>
      <Typography variant="h5" component="h1" gutterBottom>
        システム設定
      </Typography>

      <Paper sx={{ p: 3, mt: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>言語設定</InputLabel>
              <Select value="ja" label="言語設定">
                <MenuItem value="ja">日本語</MenuItem>
                <MenuItem value="en">English</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>タイムゾーン</InputLabel>
              <Select value="Asia/Tokyo" label="タイムゾーン">
                <MenuItem value="Asia/Tokyo">Asia/Tokyo (UTC+9)</MenuItem>
                <MenuItem value="UTC">UTC</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              メール設定
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="SMTPサーバー"
              value={process.env.SMTP_HOST || ""}
              disabled
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="SMTPポート"
              value={process.env.SMTP_PORT || ""}
              disabled
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              バックアップ設定
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>バックアップ頻度</InputLabel>
              <Select value="daily" label="バックアップ頻度">
                <MenuItem value="daily">毎日</MenuItem>
                <MenuItem value="weekly">毎週</MenuItem>
                <MenuItem value="monthly">毎月</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="保持期間（日）"
              type="number"
              value={30}
            />
          </Grid>

          <Grid item xs={12} sx={{ mt: 2 }}>
            <Button variant="contained" color="primary">
              設定を保存
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default Settings;
